var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEsPath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#56B5FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3 0C1.355 0 0 1.355 0 3s1.355 3 3 3c1.293 0 2.395-.843 2.813-2H14c1.117 0 2 .883 2 2s-.883 2-2 2H4c-2.197 0-4 1.803-4 4v1h.203C.66 14.706 2.156 16 4 16h8.188c.417 1.157 1.519 2 2.812 2 1.645 0 3-1.355 3-3s-1.355-3-3-3c-1.293 0-2.395.843-2.813 2H4c-1.117 0-2-.883-2-2s.883-2 2-2h10c1.844 0 3.34-1.294 3.797-3H18V6c0-2.197-1.803-4-4-4H5.812C5.396.843 4.293 0 3 0z",
    transform: "translate(-154 -620) translate(138 602) translate(16 12) translate(0 6)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEsPath);
export default __webpack_public_path__ + "static/media/icon-es-path.51d323d76f300de5f0d8c6fe694bb984.svg";
export { ForwardRef as ReactComponent };